import { PhoneIcon } from '@heroicons/react/24/solid'

import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { formatPhoneNumber } from '@/utils/number'

import { AppButton } from '..'

type Props = {
  contactPhone?: string
}

export const CallButton = ({ contactPhone }: Props) => {
  const { breakpoint } = useCurrentBreakpoint()

  const isSmallScreen = [ScreenSize.Xxs, ScreenSize.Xs, ScreenSize.Sm].includes(
    breakpoint
  )

  const call = () => {
    if (!contactPhone) {
      return
    }

    window.location.href = `tel:${contactPhone}`
  }

  if (!contactPhone) {
    return undefined
  }

  return (
    <AppButton variant="secondary" fluid className="!h-56 gap-8" onClick={call}>
      <div className="flex h-32 w-32 items-center justify-center gap-8 rounded-full bg-bronze-40">
        <PhoneIcon className="h-18 w-18" />
      </div>
      {isSmallScreen ? 'Позвонить' : formatPhoneNumber(contactPhone)}
    </AppButton>
  )
}
